import { RRule } from 'rrule';

export const makeRRuleString = options => new RRule(options).toString().replace('RRULE:', '');

export const parseStringToRRuleOptions = ical => RRule.parseString(ical);

export const rruleStringToText = ical => RRule.fromString(ical).toText();
